import React, { useState } from "react";
import { contactLinks } from "./ContactLinks";
import { WhatsWeC } from "./WhatsWe";
import whatsapp from "../../images/whatsapp.png";
import wechat from "../../images/wechat.png";
import { FaWhatsapp } from "react-icons/fa";
import { AiFillWechat } from "react-icons/ai";

export const LinksContainer = () => {
  const [isWhatsAppQRCodeOpen, setisWhatsAppQRCodeOpen] = useState(false);
  const [isWeChatQRCodeOpen, setisWeChatQRCodeOpen] = useState(false);
  return (
    <>
    <button
        onClick={() => setisWeChatQRCodeOpen(true)}
        className="links-to-social green" 
      >
        <AiFillWechat />
      </button>
      <WhatsWeC
        img={wechat}
        state={isWeChatQRCodeOpen}
        setState={setisWeChatQRCodeOpen}
        des="Scan this code using WeChat scan to get my WeChat contact card"
        boxClass="footer-wechat-qr-image-section"
        imgClass="wechat-app-qr-code-image"
        downloadNoti="WeChat QR code is downloading..."
      />
      {contactLinks.map((myLinks) => {
        const { id, links, icon, classes } = myLinks;
        return (
          <a
            href={links}
            key={id}
            className={`links-to-social ${classes}`}
            target="_blank"
            rel="noreferrer"
          >
            {icon}
          </a>
        );
      })}
      <button
        onClick={() =>  setisWhatsAppQRCodeOpen(true)}
        className="links-to-social green" 
      >
        <FaWhatsapp />
      </button>
      <WhatsWeC
        img={whatsapp}
        state={isWhatsAppQRCodeOpen}
        setState={setisWhatsAppQRCodeOpen}
        des="Scan this code using the WhatsApp camera to get my WhatsApp number"
        boxClass="footer-whatsapp-qr-image-section"
        imgClass="whats-app-qr-code-image"
        downloadNoti="WhatsApp QR code is downloading..."
      />
    </>
  );
};
